import { ConfigService } from '@/services/config';
import { MockPhotoVogueService } from './mock-service';
import { HttpPhotoVogueService } from './http-service';
import type { PhotoVogueService } from './service.interface';

let instance: PhotoVogueService | null = null;

/**
 * Singleton accessor for the PhotoVogue data service. Stores call only this factory,
 * so switching backends needs no store/UI edits: `VITE_PHOTOVOGUE_USE_MOCKS=true`
 * serves the in-memory mock; otherwise it talks to `photovogue-api` over HTTP.
 */
export const getPhotoVogueService = (): PhotoVogueService => {
  if (instance) return instance;
  instance = ConfigService.PHOTOVOGUE_USE_MOCKS
    ? new MockPhotoVogueService()
    : new HttpPhotoVogueService();
  return instance;
};

export type { PhotoVogueService } from './service.interface';
export * from './types';
export * from './filter-definitions';
export * from './bulk-actions';
export * from './defaults';
